import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';
import MultiColumnLayout from '../MultiColumnLayout';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.cream')};
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 50px 0;

  > h1:first-child,
  > h2:first-child,
  > h3:first-child,
  > h4:first-child {
    text-align: center;
    margin-bottom: 24px;
    color: ${themeGet('colors.text_dark')};
  }

  .case-study-subtitle {
    text-align: center;
    margin-bottom: 40px;
  }

  .casestudylink {
    border-bottom: none;
  }

  &.with-image {
    padding-bottom: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    /* padding: 70px 90px; */
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 90px;
  }
`;

export const Columns = styled(MultiColumnLayout)``;

export const Block = styled.div`
  border-radius: 6px;
  min-height: 100%;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  &:hover {
    /* box-shadow: 10px 10px 40px 0 #c9c9c9; */
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    flex-direction: row;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: flex;
    flex-direction: row;
    max-height: 100%;
  }
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  max-height: 180px;

  object-fit: cover;
  object-position: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: auto;
    max-height: 100%;
    object-fit: cover;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-height: 180px;
    height: 100%;
    width: 100%;
  }
`;

export const Card = styled.div`
  border-radius: 6px;
  min-height: 100%;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  .case-study-image img {
    object-fit: cover !important;
  }

  &:hover {
    /* box-shadow: 10px 10px 40px 0 #c9c9c9; */
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: block;
    flex-direction: row;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }
`;

export const Content = styled.div`
  background-color: ${themeGet('colors.neutral_1')};
  padding: 35px 25px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > h1:first-child,
  > h2:first-child,
  > h3:first-child,
  > h4:first-child,
  > h5:first-child,
  > h6:first-child {
    font-weight: 700;
    font-size: 22px;
    line-height: 32.4px;
  }

  .body-content {
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin: 24px 0;
    font-weight: normal;
  }

  a {
    margin-top: auto;
  }

  a.casestudy-cta {
    margin: 24px auto 0;
    text-decoration: none;
    text-decoration-line: none;
    text-align: center;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    min-height: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    .body-content {
      flex-grow: 1;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 100%;
    flex: 1 1 100%;
    text-align: left;
  }
`;

export const Author = styled.div`
  display: flex;
`;

export const AuthorImage = styled(Image)`
  min-width: 90px;
  max-width: 90px;
  max-height: 90px;
  object-fit: cover;
  object-position: center;

  ${Wrapper}.wide &, ${Wrapper}.Wide & {
    height: auto;
    width: 100%;
    margin: auto;
  }

  ${Wrapper}.narrow &, ${Wrapper}.Narrow & {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: 100%;
    margin: auto;
  }
`;

export const AuthorDetails = styled.div`
  width: 100%;
  font-weight: normal;
  margin-top: 10px;
  margin-left: 15px;

  p {
    font-size: 14px;
    line-height: 21.6px;
  }

  p:first-child {
    font-size: 20px;
    font-weight: 700;
    line-height: 30.86px;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 30px;

  h3,
  h4 {
    margin-bottom: 30px;
  }
`;
